import { EventChannel } from 'lbs-pi-handy/src/general-purpose/EventChannel';

// In IE, NodeList (returned from querySelectorAll) doesn't support forEach.
// This converts querySelectorAll's result to an array to give us forEach.
export function findNodes (container, selector) {
  return Array.from(container.querySelectorAll(selector));
}

let TEST_DPR;
export function setDevicePixelRatio_TEST_ONLY (dpr) {
  TEST_DPR = dpr;
}
export const resetDevicePixelRatio_TEST_ONLY = setDevicePixelRatio_TEST_ONLY;
export function getDevicePixelRatio () {
  return TEST_DPR || window.devicePixelRatio;
}

/**
 * A callback that sets up and triggers a callback when the device pixel ratio is changed. This is an indirect
 * listener because we cannot listen directly to changes in window.devicePixelRatio. Instead, we set up a
 * media query listener for deviations from the current DPR. Once this triggers we know DPR has changed, but
 * this listener won't fire again unless DPR is changed back to current, so we have to set up a listener for
 * the new DPR. Once we have a listener for a specific DPR we can cache it so we don't have multiple handlers.
 *
 * NOTE: The passed in callback fires immediately.
 *
 */
export function makeDprListener () {
  const events = new EventChannel();
  const dprTracker = {};
  let lastDpr;

  const dpr = {
    addEventListener (callback) {
      events.on('change', callback);
      const newDpr = getDevicePixelRatio();
      events.trigger('change', newDpr, lastDpr);
      lastDpr = newDpr;
      if (dprTracker[newDpr]) {
        return;
      }
      dprTracker[newDpr] = true;
      const mqString = `(resolution: ${newDpr}dppx)`;
      const mq = window.matchMedia(mqString);
      mq.addEventListener('change', () => dpr.addEventListener(callback));
    },
    removeEventListener: (callback) => events.off('change', callback)
  };
  return dpr;
}

/**
 * Attach a handler to an event for all elements that match the selector, now or in the future, from a given root
 * element
 * @param target
 * @param event
 * @param filter
 * @param callback
 */
export function delegate (target, event, filter, callback) {
  target.addEventListener(event, (e) => {
    const children = findNodes(target, filter);
    const path = getEventPath(e);
    const matchFound = !!children.find(c => path.includes(c));
    if (matchFound) {
      callback(e);
    }
  });
}

/**
 * Given an event, returns a list of elements from the document root to the event target
 * @param e
 * @returns {[]|*}
 */
export function getEventPath (e) {
  if (e.path) {
    return e.path;
  }

  const path = [];
  let node = e.target;
  while (node && node !== document.body) {
    path.push(node);
    node = node.parentNode;
  }
  return path;
}
